module.exports = __webpack_public_path__ + "img/logo-black.371ecfb6.png";